export const alignText = {
  center: 'center',
  left: 'left',
  right: 'right',
  inherit: 'inherit',
};

export const CHINA_REGION = 47;

export const DEFAULT_COUNTRY = {
  id: 233,
  flags: {
    28: 'https://cdn.3d4medical.com/accounts/upload/country_flag/28/us.jpg',
    56: 'https://cdn.3d4medical.com/accounts/upload/country_flag/56/us.jpg',
    70: 'https://cdn.3d4medical.com/accounts/upload/country_flag/70/us.jpg',
    84: 'https://cdn.3d4medical.com/accounts/upload/country_flag/84/us.jpg',
    140: 'https://cdn.3d4medical.com/accounts/upload/country_flag/140/us.jpg',
    210: 'https://cdn.3d4medical.com/accounts/upload/country_flag/210/us.jpg',
  },
  currency: {
    id: 1,
    iso: 'USD',
    symbol: '$',
    rate: 1.0,
    paypal: true,
    stripe: true,
    zero_decimal: false,
    max_total: 52999,
  },
  name: 'United States(USA)',
  iso: 'US',
  tax_rate: 0.0,
};

export type Tcountry = typeof DEFAULT_COUNTRY;

export const ENV_DOMAIN = window.location.origin.includes('nonprod')
  ? 'nonprod.'
  : '';

export const TOP_DOMAIN = window.location.origin.includes('completeanatomy.cn')
  ? 'completeanatomy.cn'
  : '3d4medical.com';

export const regionCookie = 'region_3d4m';
